const PlayerDetailsTypes = {
    GET_PLAYER_DETAILS_START:'GET_PLAYER_DETAILS_START',
    GET_PLAYER_DETAILS_SUCCESS:'GET_PLAYER_DETAILS_SUCCESS',
    SET_CURRENT_PLAYER_TEAM:'SET_CURRENT_PLAYER_TEAM',
    SET_CURRENT_PLAYER_TOURNAMENT:'SET_CURRENT_PLAYER_TOURNAMENT',
    GET_PLAYER_DETAILS_FAILED:'GET_PLAYER_DETAILS_FAILED'
}

export default PlayerDetailsTypes